import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getModuleByIdStart } from "../../../Store/Slices/formSlice";

const ItemContent = ({
    showQTItemContent,
    setshowQTItemContent,
    QTItemValues,
    handleInsertQTItemPlaceholder,
    handleQTItemValuesChange
}) => {
    const dispatch = useDispatch();
    let navbarList = useSelector((state) => state?.forms)?.navbarList;
    let formList = useSelector((state) => state?.forms)?.modules;
    let [itemPlaceholders, setItemPlaceholders] = useState([])
    let [fieldList, setFieldList] = useState([]);

    useEffect(() => {
        if (navbarList?.length) {
            let id = navbarList?.filter(item => item.name === 'Quotes')?.[0]?._id
            if (id) {
                dispatch(getModuleByIdStart(id));
            }
        }
    }, [navbarList])

    useEffect(() => {
        if (formList?.length > 0) {
            setFieldList([]);
            let sections = formList?.[0]?.fields?.sections;
            for (var i = 0; i < sections.length; i++) {
                if (sections[i].selected_list) {
                    let list = sections[i].selected_list
                    for (var j = 0; j < list.length; j++) {
                        let _value = list[j]
                        setFieldList(list => [...list, _value])
                    }
                }
            }
        }
    }, [formList])

    useEffect(() => {
        if (fieldList?.length > 0) {
            let fields = fieldList
                .map(data => ({ key: data.extra_fields.field_label, value: data.extra_fields.field_label }))
            if (fields) {
                let newItem = {
                    categoryTitle: 'QUOTES',
                    items: fields
                }
                setItemPlaceholders(prevItems => {
                    const exists = prevItems.some(item => item.categoryTitle === 'QUOTES');
                    if (!exists) {
                        return [...prevItems, newItem];
                    }
                    return prevItems;
                });
            }
        }
    }, [fieldList])

    return (
        <Modal
            show={showQTItemContent}
            onHide={() => setshowQTItemContent(false)}
            size="lg"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title className="font-17 fw-normal">
                    <span className="align-middle">Customize Item Name & Description Format</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="card p-0">
                    <div className="card-header d-flex justify-content-between">
                        <Dropdown>
                            <Dropdown.Toggle variant="light" className="with-arrow px-3" id="headFootCont_dropdownBtn">
                                <span className="pe-3">Insert Placeholders</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="max-h-400px">
                                <div className="hstack align-items-start">
                                    {itemPlaceholders.length > 0 && itemPlaceholders.map((categoryTitle, index) => (
                                        <div key={index} className={index !== 0 ? 'ps-2 border-start' : 'pe-2'}>
                                            <Dropdown.ItemText className="fw-medium dropdown-header">{categoryTitle.categoryTitle}</Dropdown.ItemText>
                                            {categoryTitle.items.map((item, itemIndex) => (
                                                <Dropdown.Item key={itemIndex} onClick={() => handleInsertQTItemPlaceholder(categoryTitle.categoryTitle, item.value)}>
                                                    {item.value}
                                                </Dropdown.Item>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <textarea rows={9} id="header_custom_cont_input" className="form-control border-0"
                        value={QTItemValues} onChange={handleQTItemValuesChange}></textarea>
                </div>
                <div className="mt-4 form-text text-muted">
                    <span className="fw-semibold pe-2">Note:</span>
                    If your content exceeds the template margin, you can adjust the margin values accordingly.
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ItemContent;